import styled from 'styled-components';
import FailedActiveSvg from '../../assets/mytrips/failed-active.svg';

const FailedActiveIcon = styled(FailedActiveSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '3.2rem'};
  height: ${props => props.height || '3.2rem'};
  margin: ${props => props.margin};
  cursor: pointer;
`;

export default FailedActiveIcon;
